import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export type Organization = ApiSchemas['OrganizationPresenter']

export default {
  async getById(id: number) {
    return wrapEndpoint(() =>
      client.GET('/organization/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
  async list(options?: ApiSchemas['ListOrganizationDto']) {
    return wrapEndpoint(() =>
      client.GET('/organization', {
        params: {
          query: options,
        },
      }),
    )
  },
  async create(body: ApiSchemas['CreateOrganizationDto']) {
    return wrapEndpoint(() =>
      client.POST('/organization', {
        body,
      }),
    )
  },
  async updateById(id: number, body: ApiSchemas['UpdateOrganizationDto']) {
    return wrapEndpoint(() =>
      client.PUT('/organization/{id}', {
        params: {
          path: {
            id,
          },
        },
        body,
      }),
    )
  },
  async deleteById(id: number) {
    await wrapEndpoint(() =>
      client.DELETE('/organization/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
